enum UploadChunkStatus {
  // defined on the server
  UPLOADED = "uploaded",
  FAILED = "failed",
  // defined only locally
  PENDING = "pending",
  RETRY = "retry",
  UPLOADING = "uploading",
  SIGNAL_COMPLETE_FILE = "complete_file",
}

export default UploadChunkStatus;
